import { render, staticRenderFns } from "./AppPaymentMethodSelect.vue?vue&type=template&id=146b3f17&"
import script from "./AppPaymentMethodSelect.vue?vue&type=script&lang=js&"
export * from "./AppPaymentMethodSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports